<template>
  <div class="ls-service-promos-top--wrapper">
    <h1>{{ promo.service.description }}</h1>
    <p>{{ promo.service.promo_description }}</p>
    <LsButton
      :text="buttonText"
      :is-uppercase="false"
      bg-color="primary-light"
      test-id="cta"
      text-color="primary"
      track-id="ls_service_promos_top-cta"
      @click="$router.push(goToOrderService())"
    />
  </div>
</template>

<script>
import VueTypes from 'vue-types';
import { LsButton } from '@/components/common';

export default {
  name: 'LsServicePromosTop',
  components: {
    LsButton,
  },
  props: {
    propertyId: VueTypes.number.isRequired,
    promo: VueTypes.shape({
      id: VueTypes.number.isRequired,
      rank: VueTypes.number,
      service: VueTypes.shape({
        id: VueTypes.number.isRequired,
        name: VueTypes.string.isRequired,
        description: VueTypes.string.isRequired,
        promo_description: VueTypes.string.isRequired,
        str_id: VueTypes.string.isRequired,
      }).isRequired.loose,
    }).isRequired.loose,
  },
  computed: {
    buttonText() {
      return `Explore ${this.promo.service.name}`;
    },
  },
  methods: {
    goToOrderService() {
      const { service, id } = this.promo;
      return {
        name:
          service.str_id === 'fertilization' || service.str_id === 'aeration'
            ? 'orderPricedServiceForm'
            : 'orderServiceForm',
        params: {
          property_id: this.propertyId,
          str_id: service.str_id,
          service_id: service.id,
          service_promo_id: id,
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.ls-service-promos-top--wrapper {
  background-color: $primary-dark;
  color: $white;
  padding: 32px 32px 32px 21px;

  h1 {
    color: $white;
    font-weight: 700;
    padding-bottom: 16px;
  }

  p {
    @media (min-width: $desktop) {
      max-width: 370px;
    }
  }

  button {
    margin-top: 24px;
  }
}
</style>
